import { UpdateCustomMessageRegionEntity } from '../../domain/entities/UpdateCustomMessageRegionEntity'

export class UpdateCustomMessageRegionModel {
  regionIds?: Array<number> | null

  constructor(dataDto: UpdateCustomMessageRegionEntity) {
    this.regionIds = dataDto.regions?.map((region) => region.id).filter((id): id is number => id !== undefined) || []
  }
}
